<template>
  <div>
    <div class="grid-content maintitle">
      <span>默认外部字段</span>
    </div>

    <div class="grid-content content-margin">
      <div class="grid-content content-margin">
        <span>选择表:</span>
        <el-select
          v-model="tableType"
          placeholder="请选择表"
          style="width: 300px"
          @change="refresh"
        >
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.name + ':' + item.define"
            :value="item.value"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
      </div>

      <div class="grid-content content-margin">
        <el-table
          ref="table"
          :data="fieldData"
          stripe
          border
          :height="tableHeight"
          style="width: 100%"
        >
          <el-table-column
            fixed
            width="160"
            :label="$t('message.操作')"
            align="center"
          >
            <template slot-scope="scope">
              <el-button-group>
                <el-button
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-edit"
                  @click="editTarget(scope.row)"
                ></el-button>
              </el-button-group>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="中文名称" width="300" fixed>
          </el-table-column>

          <el-table-column
            prop="fieldname"
            label="mongo字段名称"
            width="225"
            fixed
          >
          </el-table-column>

          <el-table-column
            prop="externalfieldname"
            label="默认外部系统字段名"
            width="225"
            fixed
          >
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-drawer
      :show-close="false"
      :size="800"
      :visible.sync="isEditMode"
      :direction="'rtl'"
      :before-close="handleClose"
    >
      <div class="grid-content subtitle">
        <span>默认外部系统字段名设置</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button size="medium" round @click.native="isEditMode = false">
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false">
            <el-button size="medium" round @click="doSave">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.确定") }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <div>
              <span>中文名称:</span>
            </div>
            <div>
              <el-input
                v-model="editData.name"
                placeholder="请选择"
                size="small"
                :disabled="true"
              >
              </el-input>
            </div>
          </tr>

          <tr>
            <div>
              <span>mongo字段名称:</span>
            </div>
            <div>
              <el-input
                v-model="editData.fieldname"
                placeholder="请选择"
                size="small"
                :disabled="true"
              >
              </el-input>
            </div>
          </tr>

          <tr>
            <div>
              <span>默认外部系统字段名:</span>
            </div>
            <div>
              <el-input
                v-model="editData.externalfieldname"
                placeholder="请输入"
                size="small"
              >
              </el-input>
            </div>
          </tr>
        </table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import userTableType from "@/utils/UserTableType";
export default {
  name: "ApiAccount",
  data() {
    return {
      appID: 188,
      tableType: 1,
      tableHeight: 500,
      typeOptions: [],
      fieldData: [],
      editData: {},
      isEditMode: false,
    };
  },

  methods: {
    editTarget(row) {
      this.editData = row;
      this.isEditMode = true;
    },

    doSave() {
      rejecthttp(
        true,
        "post",
        "/manage/fieldtrans/updatedefaultexternalfield",
        this.editData,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.refresh();
            this.isEditMode = false;
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    refresh() {
      rejecthttp(
        true,
        "get",
        "/manage/fieldtrans/gettablefields",
        {
          appid: this.appID,
          tableid: this.tableType,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.fieldData = doc.data.data;
            console.log(this.fieldData);
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },

  created() {
    this.typeOptions = userTableType.getData();
    this.refresh();
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/settings/DefaultExternalField.vue